// Recurrent clients only. New (non-recurrent) clients are not held to a limit.
// Blocks once unpaid invoice balances are past 95% of the credit limit.
export function clientCreditLimitReached(client, internalPaymentType, paymentMethod) {
  if (!client || !client.is_privileged) return false;
  if (serviceSettlesWithoutCredit(internalPaymentType, paymentMethod)) return false;
  const rawLimit = client.client_credit_limit;
  if (rawLimit === null || rawLimit === undefined || String(rawLimit).trim() === '') return false;
  const limit = Number(rawLimit);
  const balance = Number(client.open_balance || 0);
  if (!Number.isFinite(limit) || limit < 0 || !Number.isFinite(balance)) return false;
  if (limit === 0) return balance > 0;
  return balance / limit > 0.95;
}

function serviceSettlesWithoutCredit(internalPaymentType, paymentMethod) {
  const paymentType = internalPaymentType == null ? '' : String(internalPaymentType).trim();
  const method = paymentMethod == null ? '' : String(paymentMethod).trim().toUpperCase();
  return paymentType === '1' || method === 'PUE';
}
